import Axios from "axios";
import $ from 'jquery';
import {LookupJourneyResponse, LookupJourneysRequest} from "./lookup-journeys";

function initialisePrintedManualRefunds() {
    const $bookingReferenceField = $("input[name='BookingReference']");
    const $emailField = $("input[name='Email']");

    function evaluateIfPrintedTicketInformationShouldBeShown() {
        const bookingReference = $bookingReferenceField.val();
        const email = $emailField.val();
        if (bookingReference && email) {
            Axios.post<LookupJourneysRequest, Array<LookupJourneyResponse>>('/api/LookupJourneys', {
                'bookingReference': bookingReference,
                'email': email
            }).then(r => { 
                // @ts-ignore
                const result = r.data as Array<LookupJourneyResponse>;
                const anyPrinted = result.some(v => v.refundStatus.journeys.some(j => j.isPrinted));
                $(".printed-ticket-warning").toggleClass('hide', !anyPrinted);
            }).catch(e => {
                $(".printed-ticket-warning").addClass('hide');
            });
        }
    }

    evaluateIfPrintedTicketInformationShouldBeShown();

    $bookingReferenceField.on('blur', evaluateIfPrintedTicketInformationShouldBeShown);
    $emailField.on('blur', evaluateIfPrintedTicketInformationShouldBeShown);
}

export default initialisePrintedManualRefunds;
